import { supabase } from '../config/supabaseConfig.ts';

export const proyectTypesService = {
  getAll: async () => {
    try {
      const { data, error } = await supabase
        .from('project_types')
        .select('*');
      
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al obtener tipos de proyectos:', error);
      throw error;
    }
  }

}
    